<template>
  <f-field class="from17-collection-toggle">
    <template v-slot:label>{{ $vt(component.title) }}</template>
    <template v-slot:content>
      <div class="f-media-list">
        <FSexyScroll style="min-height: 120px; max-height: 200px">
          <div class="collection-toggle-inner">
            <div
              v-for="(item, key) in component.items"
              :key="key"
              class="collection-toggle-item"
            >
              <div><font-awesome-icon :icon="['fas', 'user']" /></div>
              <div>{{ $vt(item.label) }}</div>
              <div>
                <FCheckbox
                  :variant="['simple']"
                  :default="item.selected"
                  :checked="item.selected"
                  @update:checked="
                    (value) => handler.action(item['#id'], 'toggle', [value])
                  "
                />
              </div>
            </div>
          </div>
        </FSexyScroll>
      </div>
    </template>
    <template v-slot:helper>{{ $vt(component.description) }}</template>
  </f-field>
</template>
<script>
export default {
  translate25Context: 'vform17',
  props: ["component", "handler"],
};
</script>

<style lang="scss">
.from17-collection-toggle {
  .f-media-list {
    /* Medias list */

    box-sizing: border-box;

    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;

    /* White */
    /* Grey 100 */

    border: 1px solid var(--white-a25);
    border-radius: 0px 0px 8px 8px;

    /* Inside auto layout */

    flex: none;
    order: 1;
    flex-grow: 1;

    .f-sexy-scroll {
      width: 100%;
    }
  }

  .collection-toggle-inner {
    display: flex;
    flex-direction: column;
    padding: 8px;
    gap: 8px;

    .collection-toggle-item {
      height: 40px;

      display: flex;
      flex-direction: row;
      align-items: center;

      padding: 8px;
      gap: 8px;

      flex-basis: 100%;

      align-items: center;

      :nth-child(2) {
        flex-basis: 100%;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>